import React from 'react';
import { Helmet } from 'react-helmet-async';

const StructuredData = () => {
  const localBusinessSchema = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    'name': 'GrooveWash - YOUR BUSINESS NAME', // TODO: Replace with your actual business name
    'image': 'https://groovewash.com/logo.svg', // TODO: Replace with your actual logo URL if different
    '@id': 'https://groovewash.com/', // TODO: Replace with your homepage URL
    'url': 'https://groovewash.com/', // TODO: Replace with your homepage URL
    'telephone': '+1-XXX-XXX-XXXX', // TODO: Replace with your phone number
    'priceRange': '$$', // TODO: Example, adjust as needed (e.g., $, $$, $$$)
    'address': {
      '@type': 'PostalAddress',
      'streetAddress': 'YOUR STREET ADDRESS (Optional, if you have a physical location)', // TODO: Replace or remove
      'addressLocality': 'Minneapolis', // TODO: Replace with your city
      'addressRegion': 'MN', // TODO: Replace with your state
      'postalCode': 'YOUR ZIP CODE', // TODO: Replace
      'addressCountry': 'US'
    },
    'geo': { // Optional, good for service area businesses too
      '@type': 'GeoCoordinates',
      'latitude': 'YOUR_LATITUDE', // TODO: Replace with your latitude
      'longitude': 'YOUR_LONGITUDE' // TODO: Replace with your longitude
    },
    'openingHoursSpecification': [ // TODO: Adjust to your actual hours
      {
        '@type': 'OpeningHoursSpecification',
        'dayOfWeek': [
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday'
        ],
        'opens': '09:00',
        'closes': '17:00'
      },
      {
        '@type': 'OpeningHoursSpecification',
        'dayOfWeek': 'Saturday',
        'opens': '10:00',
        'closes': '15:00'
      }
    ],
    'department': [
      {
        '@type': 'Service',
        'name': 'Ultrasonic Vinyl Record Cleaning',
        'description': 'Professional ultrasonic cleaning for vinyl records to restore audio fidelity and preserve your collection.',
        'areaServed': {
          '@type': 'AdministrativeArea',
          'name': 'Minnesota'
        },
        'serviceType': 'Record Cleaning',
        'provider': {
          '@type': 'LocalBusiness',
          'name': 'GrooveWash - YOUR BUSINESS NAME' // TODO: Replace
        },
        // Optional: add offers for specific services
        // 'offers': {
        //   '@type': 'Offer',
        //   'price': '10', // Example price
        //   'priceCurrency': 'USD'
        // }
      },
      {
        '@type': 'Service',
        'name': 'Vinyl Record Digitization',
        'description': 'High-quality digitization of vinyl records to preserve your music in digital formats.',
         'areaServed': {
          '@type': 'AdministrativeArea',
          'name': 'Minnesota'
        },
        'serviceType': 'Record Digitization',
        'provider': {
          '@type': 'LocalBusiness',
          'name': 'GrooveWash - YOUR BUSINESS NAME' // TODO: Replace
        },
      }
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(localBusinessSchema)}
      </script>
    </Helmet>
  );
};

export default StructuredData; 